"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToBannerProps({ data, mappers, packages, forms }) {
    let image = null;
    if (data.featuredImage?.length) {
        image = mappers.mapBlock({
            block: data.featuredImage?.[0],
            mappers,
        });
    }
    let backgroundImage = null;
    if (data.backgroundImage?.length) {
        backgroundImage = mappers.mapBlock({
            block: data.backgroundImage?.[0],
            mappers,
        });
    }
    let mobileImage = null;
    if (data.mobileImage?.length) {
        image = mappers.mapBlock({
            block: data.mobileImage?.[0],
            mappers,
        });
    }
    let mobileBackgroundImage = null;
    if (data.mobileBackgroundImage?.length) {
        mobileBackgroundImage = mappers.mapBlock({
            block: data.mobileBackgroundImage?.[0],
            mappers,
        });
    }
    return {
        image,
        mobileBackgroundImage,
        backgroundImage,
        mobileImage,
        mainContent: data?.mainContent
            ? mappers.mapRichText({ richText: data.mainContent, mappers, packages, forms })
            : null,
        centerAligned: data?.centerAligned,
        contentAlignment: data?.contentAlignment,
        imageAlignment: data?.imageAlignment,
        layout: data?.layout,
        backgroundColor: data?.backgroundColor,
        textColor: data?.textColor,
        mobileTextColor: data?.mobileTextColor,
        /**
         * This is the ID that will be used when creating a jump link to this section. It can either be a link on this page or an external link from a different page. e.g. safest-cities.
         */
        jumpLinkID: data?.jumpLinkID,
        id: data?.id,
    };
}
exports.default = mapToBannerProps;
